
import { FloatUserConfigurationField } from '@/types/workerConfiguration'
import { PropType, defineComponent } from 'vue'

export default defineComponent({
  emits: {
    'update:modelValue': (value: number | string) => ['string', 'number'].includes(typeof value)
  },
  props: {
    field: {
      type: Object as PropType<FloatUserConfigurationField>,
      required: true
    },
    modelValue: {
      type: [String, Number],
      required: true
    }
  }
})
